import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { track } from "@/lib/track";

const PHONE = "+33783977370";

// Pre-formatted WhatsApp message with checklist
const DEFAULT_MSG = `Bonjour VlaDriver 👋

Je souhaite un devis VTC — voici les détails :

📅 Date :
🕐 Heure :
📍 Départ :
🎯 Destination :
👥 Passagers :
🧳 Bagages :

Merci !`;

const WhatsAppButton = () => {
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  // Show label bubble for 4s on first mount (desktop teaser), then collapse
  useEffect(() => {
    if (sessionStorage.getItem("wa-teased")) return;
    const t = setTimeout(() => {
      setOpen(true);
      sessionStorage.setItem("wa-teased", "1");
      setTimeout(() => setOpen(false), 4500);
    }, 2000);
    return () => clearTimeout(t);
  }, []);

  const message = encodeURIComponent(DEFAULT_MSG);
  const link = `https://wa.me/${PHONE.replace("+", "")}?text=${message}`;

  if (dismissed) return null;

  return (
    <div className="fixed bottom-6 left-6 z-40 flex items-end gap-3">
      {/* Label bubble */}
      {open && (
        <div
          data-testid="whatsapp-teaser"
          className="hidden md:flex items-center gap-2 bg-white rounded-2xl px-4 py-2.5 shadow-2xl border border-black/5 animate-fadeIn"
          style={{ animation: "waBubble 0.4s ease-out" }}
        >
          <button
            onClick={() => setDismissed(true)}
            aria-label="Fermer"
            className="text-black/30 hover:text-black/60 -ml-1 mr-1"
          >
            <X size={14} />
          </button>
          <div className="text-sm">
            <div className="font-semibold text-[#0F1115]">
              Devis en 2 minutes
            </div>
            <div className="text-xs text-black/60">
              Réponse immédiate · WhatsApp
            </div>
          </div>
        </div>
      )}

      {/* Floating circle */}
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => track("whatsapp_click")}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        data-testid="whatsapp-float-btn"
        aria-label="Devis WhatsApp en 2 minutes"
        className="relative w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] hover:bg-[#1ebe57] flex items-center justify-center shadow-2xl pulse-wa transition-all hover:scale-110"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className="w-7 h-7 md:w-8 md:h-8 fill-white"
          aria-hidden="true"
        >
          <path d="M17.498 14.382c-.301-.15-1.767-.867-2.04-.966-.273-.101-.473-.15-.673.15-.197.295-.771.964-.944 1.162-.175.195-.349.21-.646.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.77-1.66-2.07-.174-.3-.019-.465.13-.615.136-.135.301-.345.451-.523.146-.181.194-.301.297-.496.1-.21.049-.375-.025-.524-.075-.15-.672-1.62-.922-2.206-.24-.584-.487-.51-.672-.51-.172-.015-.371-.015-.571-.015-.2 0-.523.074-.797.359-.273.3-1.045 1.02-1.045 2.475s1.07 2.865 1.219 3.075c.149.195 2.105 3.195 5.1 4.485.714.3 1.27.48 1.704.629.714.227 1.365.195 1.88.121.574-.091 1.767-.721 2.016-1.426.255-.705.255-1.29.18-1.425-.074-.135-.27-.21-.57-.345m-5.446 7.443h-.016a9.870 9.870 0 01-5.031-1.378l-.361-.214-3.741.975 1.005-3.6-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
        {/* Badge "2 min" */}
        <span className="absolute -top-1 -right-1 bg-[#D4AF37] text-black text-[10px] font-bold px-1.5 py-0.5 rounded-full border-2 border-[#0A0B0D]">
          2 min
        </span>
      </a>

      <style>{`
        @keyframes waBubble {
          from { opacity: 0; transform: translateX(-8px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </div>
  );
};

export default WhatsAppButton;
